module.exports = __webpack_public_path__ + "img/tsc.c7eb58e2.png";